import { v4 as uuidv4 } from 'uuid'

import {
  addTruck,
  approveTruck,
  deleteTruck,
  editTruck,
  EquipmentStatus,
  fetchRemovedTrucks,
  missingTruckFields,
  rejectTruck,
  restoreTruck,
  Truck,
  TruckClassLabels,
  TruckCommonClasses,
} from '../models/equipment'
import { uploadTrucks } from '../models/insuranceApplication'
import { EquipmentTable, type EquipmentTableConfig } from './EquipmentTable'

export const truckConfig: EquipmentTableConfig = {
  type: 'trucks',
  label: 'truck',
  labelPlural: 'trucks',
  vehicleClasses: TruckClassLabels,
  commonVehicleClasses: TruckCommonClasses,
  makePlaceholder: 'Freightliner',
  modelPlaceholder: 'Cascadia',
  classFieldLabel: 'Vehicle class',
  missingFields: missingTruckFields,
  createEmpty: () => ({
    id: uuidv4(),
    vehicleNumber: '',
    telematicsId: '',
    vin: '',
    make: '',
    model: '',
    year: 0,
    licensePlate: '',
    licenseState: '',
    status: EquipmentStatus.ACTIVE,
    dateCreated: '',
    dateUpdated: '',
    vehicleClass: null,
    weightClass: null,
    price: null,
  }),
  upload: async (file: File, orgId: string) => {
    const { trucks, warning } = await uploadTrucks(orgId, file)
    return { items: trucks, warning }
  },
  uploadFieldColumns: [
    ['VIN', 'Make', 'Model'],
    ['Year', 'Vehicle class', 'Weight class'],
    ['Registered state (optional)', 'License plate (optional)', 'Value (optional)'],
  ],
  apiAdd: (data, orgId) => addTruck(orgId, data),
  apiEdit: (id, data, orgId) => editTruck(orgId, id, data),
  apiDelete: (id, orgId) => deleteTruck(orgId, id),
  apiFetchRemoved: (orgId) => fetchRemovedTrucks(orgId),
  apiRestore: (id, orgId) => restoreTruck(orgId, id),
  apiApprove: (orgId, id) => approveTruck(orgId, id),
  apiReject: (orgId, id) => rejectTruck(orgId, id),
}

interface TrucksTableProps {
  trucks: Truck[]
  setTrucks: (trucks: Truck[]) => void
  handleSubmit?: (trucks: Truck[]) => void
  footer?: React.ReactNode
  onDelete?: (truck: Truck) => void
  onEdit?: (truck: Truck) => void
  onAdd?: (truck: Truck) => void
  onRestore?: (truck: Truck) => void
  addCtaOnTop?: boolean
  readOnly?: boolean
  orgId: string
  hideHeading?: boolean
  heading?: string
  searchable?: boolean
  enforceCarrierRequired?: boolean
  compact?: boolean
  notice?: React.ReactNode
}

export function TrucksTable({ trucks, setTrucks, ...rest }: TrucksTableProps) {
  return <EquipmentTable items={trucks} setItems={setTrucks} config={truckConfig} {...rest} />
}
